import { useEffect } from 'react';

import { reidentifyStaleGuest } from '@jane/bloom/services/tracking/mixpanel';

type UseMixpanelReidentifyParams = {
  enabled: boolean;
  isGuest: boolean;
  jdid?: string;
};

/**
 * When enabled for an anonymous shopper, resets Mixpanel so a stale
 * identify-set distinct id is replaced with a native `$device:` id. No-op for
 * signed-in users and for guests already on a native id.
 */
export const useMixpanelReidentify = ({
  enabled,
  isGuest,
  jdid,
}: UseMixpanelReidentifyParams): void => {
  useEffect(() => {
    if (enabled && isGuest) {
      reidentifyStaleGuest(jdid);
    }
  }, [enabled, isGuest, jdid]);
};
